import { Expose } from "class-transformer";

export class UpdateAddressDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  address: string;

  @Expose()
  postalCode: string;

  @Expose()
  city: string;

  @Expose()
  province: string;

  @Expose()
  country: string;
}
